export default {
  ra: {
    action: {
      add: "Gehitu",
      add_filter: "Gehitu iragazkia",
      back: "Atzera joan",
      bulk_actions: "1 item hautatuta |||| %{smart_count} item hautatuta",
      cancel: "Utzi",
      clear_input_value: "Garbitu balioa",
      clone: "Klonatu",
      close: "Itxi",
      close_menu: "Itxi menua",
      confirm: "Baieztatu",
      create: "Sortu",
      delete: "Ezabatu",
      edit: "Editatu",
      expand: "Zabaldu",
      export: "Esportatu",
      list: "Zerrendatu",
      open_menu: "Ireki menua",
      refresh: "Freskatu",
      remove: "Ezabatu",
      remove_filter: "Ezabatu iragazkia",
      save: "Gorde",
      search: "Bilatu",
      show: "Bistaratu",
      sort: "Ordenatu",
      undo: "Desegin",
    },
    auth: {
      auth_check_error: "Mesedez, jarraitzeko, hasi saioa",
      logout: "Itxi saioa",
      password: "Pasahitza",
      sign_in: "Sartu",
      sign_in_error: "Autentifikazioak huts egin du. Saiatu berriro, mesedez",
      user_menu: "Profila",
      username: "Erabiltzailea",
    },
    boolean: {
      true: "Bai",
      false: "Ez",
      null: "",
    },
    input: {
      file: {
        upload_several:
          "Arrastatu fitxategi batzuk igotzeko, edo egin klik hautatzeko.",
        upload_single:
          "Arrastatu fitxategi bat igotzeko edo klik egin hautatzeko.",
      },
      image: {
        upload_several:
          "Arrastatu irudi batzuk igotzeko edo klik egin hautatzeko.",
        upload_single:
          "Arrastatu irudi bat igotzeko, edo egin klik hautatzeko.",
      },
      references: {
        all_missing: "Ezin da erreferentzia-daturik aurkitu.",
        many_missing:
          "Lotutako erreferentzietako bat, gutxienez, ezin da eskuratu",
        single_missing:
          "Ez dirudi horri lotutako erreferentzia eskuragarri dagoenik.",
      },
      password: {
        toggle_visible: "Ezkutatu pasahitza",
        toggle_hidden: "Bistaratu pasahitza",
      },
    },
    message: {
      about: "Honi buruz",
      are_you_sure: "Ziur zaude?",
      bulk_delete_content:
        "Ziur zaude %{name} hau ezabatu nahi duzula? |||| Ziur %{smart_count} item hauek ezabatu nahi dituzula?",
      bulk_delete_title:
        "Ezabatu %{name} |||| Ezabatu %{smart_count} %{name} item",
      delete_content: "Ziur zaude item hau ezabatu nahi duzula?",
      delete_title: "Ezabatu %{name} #%{id}",
      details: "Xehetasunak",
      error:
        "Errore bat gertatu da bezeroan, eta ezin izan da zure eskaera osatu",
      invalid_form: "Inprimakia ez da baliozkoa. Egiaztatu errorerik dagoen",
      loading: "Orria kargatzen ari da. Itxaron pixka bat, mesedez.",
      no: "Ez",
      not_found:
        "Edo okerreko URLa idatzi duzu edo okerreko esteka erabili duzu.",
      yes: "Bai",
      unsaved_changes:
        "Egin dituzun aldaketa batzuk ez dira gorde. Ziur zaude ezikusi egin nahi diezula?",
    },
    navigation: {
      next: "Hurrengoa",
      no_more_results:
        "%{page} orrialde-kopurua mugatik kanpo dago. Probatu aurreko orrialdearekin",
      no_results: "Ez da aurkitu emaitzarik",
      page_out_from_begin: "Ezin zara joan 1. orrialdea baino aurrerago",
      page_out_from_end: "Ezin zara joan azken orrialdea baino atzerago",
      page_out_of_boundaries: "%{page} orrialde-kopurua mugatik kanpo dago",
      page_range_info: "%{offsetBegin}-%{offsetEnd} / %{total}",
      page_rows_per_page: "Orri bakoitzeko lerroak:",
      prev: "Aurrekoa",
    },
    notification: {
      bad_item: "Okerreko elementua",
      canceled: "Ekintza bertan behera geratu da",
      created: "Elementua sortu da",
      data_provider_error:
        "Datu-hornitzailearen errorea Xehetasun gehiago jakiteko, kontsultatu kontsola",
      deleted: "Elementua ezabatu da |||| %{smart_count} elementu ezabatu dira",
      http_error: "Komunikazio-errorea egon da zerbitzariarekin",
      item_doesnt_exist: "Elementu hori ez dago",
      logged_out: "Saioa amaitu da. Konektatu berriro",
      updated:
        "Elementua eguneratu da |||| %{smart_count} elementu eguneratu dira",
      i18n_error: "Ezin izan dira kargatu zehaztutako hizkuntzako itzulpenak",
    },
    page: {
      create: "Sortu %{name}",
      dashboard: "Taula",
      edit: "%{name} #%{id}",
      empty: "Oraindik ez du %{name}(r)ik",
      error: "Zerbait gaizki atera da",
      invite: "Bat gehitu nahi duzu?",
      list: "%{name}(r)en zerrenda",
      loading: "Kargatzen",
      not_found: "Ez da aurkitu",
      show: "%{name} #%{id}",
    },
    validation: {
      email: "Baliozko helbide elektroniko bat adierazi behar da",
      maxLength: "Gehienez %{max} karaktere eduki behar ditu",
      maxValue: "Gehienez %{max} izan behar du",
      minLength: "Gutxienez %{max} karaktere eduki behar ditu",
      minValue: "Gutxienez %{min} izan behar du",
      number: "Zenbaki bat izan behar du",
      oneOf: "Hauetako bat izan behar du: %{options}",
      regex: "Formatu jakin batekin bat etorri behar du (regexp) %{pattern}",
      required: "Nahitaezkoa",
    },
  },
};
